import React, { Component } from 'react';

import { connect } from 'react-redux'
import 'whatwg-fetch'
import { jsonResponseHandler } from '../utils/FetchHelper'
import classnames from 'classnames';
import filesize from 'filesize'
import querystring from 'query-string'
import {closePopup, hideLoadingPopup, showErrorToastPopup, showLoadingPopup, showSkinSavePopup} from '../actions/popup';
import {Router} from 'react-router'
import SkinPopupLayer from "../components/design/skin/SkinPopupLayer";
import LoadErrorBox from "../components/common/LoadErrorBox";
import LoadingBox from "../components/common/LoadingBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";

function tistoryFilesize(size) {
  return filesize(size, {spacer:''})
}

@connect(state => ({}),
dispatch => ({
    handleShowSkinAddPopup: (title, description, callBack) => {
        dispatch(showSkinSavePopup(title, description, callBack))
    },
    handlePopupClose: () => {
        dispatch(closePopup())
    },
    handleShowErrorToastPopup: (title, description) => {
        dispatch(showErrorToastPopup(title, description))
    },
    handleShowLoadingPopup: (loadingPopupMessage) => {
        dispatch(showLoadingPopup(loadingPopupMessage))
    },
    handleHideLoadingPopup: () => {
        dispatch(hideLoadingPopup())
    },
    dispatch
}))
class SkinAddApp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            initialized : InitStatus.INIT_READY,
            fileList: [],
            totalSize : 0,
            bgType: 'bg_skin1',
            selectedImageUrl: null
        };

        this.renderItems = this.renderItems.bind(this);
        this.handleSelectBg = this.handleSelectBg.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.handleDeleteFile = this.handleDeleteFile.bind(this);
        this.handleFileListChange = this.handleFileListChange.bind(this);
        this.handleSaveSkin = this.handleSaveSkin.bind(this);
        this.init = this.init.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    init() {

        const { dispatch } = this.props;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/design/skin/add.json"), {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                    fileList: data.fileList,
                    totalSize: data.totalSize
                })
            })
            .catch(e => {
                console.error(e);
                this.setState({
                    initialized : InitStatus.INIT_FAIL,
                })
            })
    }

    handleSelectBg(bg) {
        this.setState({
            bgType: bg
        })
    }

    handleFileListChange(fileList, totalSize) {
        this.setState({
            fileList: fileList,
            totalSize: totalSize
        })
    }

    handleUploadFile(e) {

        const { dispatch } = this.props;
        const { file } = this.refs
        let files = file.files

        if (files.length === 0) {
            return
        }

        for (var i = 0; i < files.length; i++) {
            let afile = files.item(i);
            let formdata = new FormData()
            formdata.append("files[]", afile, afile.name)

            fetch(addPrefix("/manage/design/skin/addFile.json"), {
                method: 'post',
                credentials: "include",
                body: formdata
            })
                .then(jsonResponseHandler(dispatch))
                .then(r => r.json())
                .then(data => {
                    this.handleFileListChange(data.fileList, data.totalSize)
                })
                .catch(e => {
                    console.error(e)
                })
        }
        file.value = "";
    }

    handleDeleteFile(e, filename) {

        const { dispatch } = this.props;

        if (confirm("선택한 파일을 삭제하시겠습니까?") === true)
            return fetch(addPrefix("/manage/design/skin/deleteFile.json"), {
                method: 'delete',
                credentials: "include",
                headers: {'Content-Type':'application/x-www-form-urlencoded'},
                body: querystring.stringify({
                    filename: filename
                })
            })
                .then(jsonResponseHandler(dispatch))
                .then(r => r.json())
                .then(data => {
                    this.handleFileListChange(data.fileList, data.totalSize)
                })
                .catch(e => {
                    console.error(e)
                    alert("삭제하지 못했습니다.")
                })
    }

    handleSaveSkin() {
        const { dispatch } = this.props;
        this.props.handleShowSkinAddPopup('스킨 저장', '업로드한 스킨은 보관한 스킨과 함께 최대 30개까지 보관할 수 있습니다.',
            (archiveName)=>{
                this.props.handlePopupClose();
                this.props.handleShowLoadingPopup('저장 중입니다.');
                // 이름이 겹치는 지 확인
                fetch(addPrefix("/manage/design/skin/checkArchiveNameAvailability.json?archiveName="+archiveName), {
                    method: 'get',
                    credentials: "include",

                })
                    .then(jsonResponseHandler(dispatch))
                    .then(r => r.json())
                    .then(data => {
                        let ok = false;
                        if (data['DUPLICATED']) {
                            ok = confirm("같은 이름의 저장된 스킨이 있습니다.\n스킨을 덮어씌우겠습니까?");
                        }
                        else {
                            ok = true;
                        }
                        if (ok) {
                            let formdata = new FormData()
                            formdata.append("skinname", archiveName)

                            fetch(addPrefix("/manage/design/skin/add.json"), {
                                method: 'post',
                                credentials: "include",
                                body: formdata
                            })
                                .then(jsonResponseHandler(dispatch))
                                .then(r => r.json())
                                .then(data => {
                                    this.props.handleHideLoadingPopup();
                                    this.props.history.push('/design/skin');
                                })
                                .catch(e => {
                                    console.error(e)
                                    this.props.handleHideLoadingPopup();
                                    // this.props.handleShowErrorToastPopup('등록에 실패했습니다.', '다시 시도해 주세요.')
                                })
                        } else {
							this.props.handleHideLoadingPopup();
						}
                    })
                    .catch(e => {
                        this.props.handleHideLoadingPopup();
                        console.error(e)
                    })
            }
        );
    }

    renderItems() {
        if (this.state.fileList.length == 0)
            return (<p className="txt_none">추가된 파일이 없습니다.</p>);
        return (
			<ul className="list_skinadd">
                {this.state.fileList.map(file =>
					<li className={classnames({'on':file.url==this.state.selectedImageUrl})}>
						<a className="link_skinadd" onClick={(e) => {if (file.filename.endsWith('jpg')||file.filename.endsWith('jpeg')||file.filename.endsWith('png')||file.filename.endsWith('bmp')||file.filename.endsWith('gif'))this.setState({selectedImageUrl: file.url})}}>
							<span className="txt_ellip">{file.label}</span>
							<span className="txt_etc">({tistoryFilesize(file.size)})</span>
						</a>
						<button type="button" className="btn_del" onClick={(e)=> this.handleDeleteFile(e, file.filename)}><span className="ico_blog ico_del">삭제</span></button>
					</li>
                )}
			</ul>
        );
    }

    render() {
        const {initialized} = this.state;

        return (
            <div className="inner_article decoration_article">
                <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
                { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
                { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
                { (initialized === InitStatus.INIT_SUCCESS ) &&
                <div className="blog_skinadd">
                    <h3 className="tit_cont">스킨등록</h3>
                    <div className="wrap_set">
                        <div className="desc_skinadd">
                            <p className="txt_skinadd">
                                등록된 스킨은 보관함에 저장됩니다.<br />
                                저장 전 index.xml, skin.html, style.css 등 파일이 모두 업로드됐는지 확인해주세요.
                                <a href="https://tistory.github.io/document-tistory-skin/" target="_blank" className="link_guide">
                                    스킨제작가이드 보기
                                </a>
                            </p>
                            <label className="btn_preview lab_btn">
                                추가 <input type="file" className="btn_g" ref="file" onChange={this.handleUploadFile}  multiple/><span className="txt_size">( <em className="txt_current">{tistoryFilesize(this.state.totalSize)}</em> / 20MB )</span>
                            </label>
                        </div>
                        <form>
                            <div className="info_skinadd">
                                <div className="item_skinadd">
                                    <strong className="tit_set">파일목록</strong>
                                    <div className="box_skinadd">
                                        { this.renderItems() }
                                    </div>
                                </div>
                                <div className="item_skinadd">
                                    <strong className="tit_set">
                                        미리보기
                                        <span className="wrap_btn">
                                <button type="button" className={classnames({'btn_bg':true, 'on':this.state.bgType == 'bg_skin1'})} onClick={(e) => this.handleSelectBg('bg_skin1')}><span className="bg_skin bg_skin1">배경 Type 1</span></button>
                                <button type="button" className={classnames({'btn_bg':true, 'on':this.state.bgType == 'bg_skin2'})} onClick={(e) => this.handleSelectBg('bg_skin2')}><span className="bg_skin bg_skin2">배경 Type 2</span></button>
                            </span>
                                    </strong>
                                    <div className={classnames({'box_skinadd':true, [this.state.bgType]:true })} style={{ whiteSpace: 'nowrap', textAlign: 'center'}}>
                                        <span className="helper" style={{display: 'inline-block', height: '396px',verticalAlign: 'middle'}}></span>
                                        {this.state.selectedImageUrl != null &&(
                                            <img src={this.state.selectedImageUrl}  style={{maxWidth: '100%', maxHeight: '100%', verticalAlign: 'middle'/*, position: 'absolute', margin: 'auto', top: '0', left: '0', right: '0',bottom: '0'*/}}/>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <fieldset>
                                <legend className="screen_out">저장 버튼</legend>
                                <button type="button" className={classnames({'btn_save':true,'btn_off':this.state.fileList.length == 0})} onClick={this.handleSaveSkin} disabled={this.state.fileList.length == 0}>저장</button>
                            </fieldset>
                        </form>
                    </div>
                    <SkinPopupLayer/>
                </div>}
            </div>
        );
    }
}

export default SkinAddApp;
